import styled from 'styled-components';

export const ExpiredStepContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 467px;
    margin: auto;

    .title {
        text-align: center;
        margin-bottom: 0;
        margin-top: 24px;
    }

    .expired-icon {
        margin-top: 38px;
        max-width: 128px;

        ${(props) => props.theme.breakpointTo.sm} {
            max-width: 103px;
            height: 103px;
        }
    }

    .time {
        display: flex;
        gap: 10px;
        justify-content: flex-start;
        align-items: center;
        ${(props) => props.theme.typography.h2};
        line-height: 28px;
        color: ${(props) => props.theme.palette.secondaryA4};
        margin-top: 32px;
    }

    .sub-title {
        margin-top: 24px;
        text-align: center;
        max-width: 286px;

        & + & {
            margin-top: 8px;
        }
    }
`;
